var elevationStyles = {"elevationLowest":"elevations_elevationLowest__2EAWe","elevationLow":"elevations_elevationLow__2KW2_","elevationMid":"elevations_elevationMid__2x4yS","elevationHigh":"elevations_elevationHigh__1NOyt","elevationHighest":"elevations_elevationHighest__2eihZ"};

export default elevationStyles;
//# sourceMappingURL=elevations.css.js.map
